import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_pro_more",
  "use": "icon-home_pro_more-usage",
  "viewBox": "0 0 11.84 13.52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.84 13.52\" id=\"icon-home_pro_more\"><defs><style>#icon-home_pro_more .a{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class=\"a\" d=\"M-2606.09,882.6l9.467,5.736-9.467,5.057\" transform=\"translate(2607.463 -881.229)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol